// No navegador: baixa o arquivo gerado (PDF, planilha CSV).
export async function salvarECompartilhar(dados: Uint8Array, nome: string, mime: string, _historico = true) {
  const url = URL.createObjectURL(new Blob([dados as BlobPart], { type: mime }));
  const a = document.createElement('a');
  a.href = url; a.download = nome; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
